import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getApiBaseUrl, withProjectPath } from 'services/projectContext';

/**
 * Format json values into query params for fastapi
 * @param json json data to be formatted
 * @returns URLSearchParams instance containing the values from json
 */
export const jsonToUrlSearchParams = (json) => {
    const formattedData = new URLSearchParams();
    Object.entries(json).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item) => formattedData.append(key, item));
        } else if (value != null) {
            formattedData.append(key, String(value));
        }
    });
    return formattedData;
};

export const getBaseQuery = (url) =>
    fetchBaseQuery({
        baseUrl: `${getApiBaseUrl()}${withProjectPath(url)}`,
        paramsSerializer: (params) => jsonToUrlSearchParams(params).toString(),
        prepareHeaders: (headers, { getState }) => {
            headers.set('authorization', `Bearer ${getState().auth.accessToken}`);
            return headers;
        },
    });
